import  { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../hook/useNotification";
import {  applyCoupon } from "../../redux/actions/cartAction";
import { useTranslation } from "react-i18next";


const ApplyCouponHook = () => {
  var user = "";
  if (localStorage.getItem("user") != null) {
    user = JSON.parse(localStorage.getItem("user"));
  }
  const dispatch = useDispatch();
  const [couponName, setCouponName] = useState("");
  const [loading, setLoading] = useState(false);

  const [couponId, setCouponId] = useState('')


const {t} = useTranslation()

  const onChangeCoupon = (e) => {
    setCouponName(e);
  };
  const handleSubmitCoupon = async () => {

    if(!user) return notify(t("Log in first"), "warn");

    if (couponName === "") {
      notify(t("Enter the discount coupon"), "warn");
      return;
    }

    let trimmedCouponName=couponName?.trim();
    console.log('trimmedCouponName',trimmedCouponName);
    setLoading(true);
    await dispatch(applyCoupon(couponName, { userId: user._id }));
    setLoading(false);
  };

  const res = useSelector((state) => state.cartReducer.applyCoupon);

  useEffect(() => {
    if (loading === false) {
      if (res && res.success === true) {
        notify(t("Coupon applied"), "success");
        setCouponId(res.couponId)
        // console.log(res.couponId)
        // console.log(res?.couponId)
        console.log('res');
        console.log(res);

        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } 
      // else {
      //   notify(t("The coupon is incorrect"), "error");
      //   setTimeout(() => {
      //     window.location.reload(false);
      //   }, 1000);
      // }
    }
  }, [loading, res]);


  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const vatValue = settingsRes?.data?.vatValue




  return [couponName, onChangeCoupon, handleSubmitCoupon, vatValue, settingsRes, res, couponId,loading];
};

export default ApplyCouponHook;
